import { z } from 'zod';

export const getImpactAnswersDtoSchema_AccommodationPublic = z.array(
  z.object({
    id: z.number(),
    userId: z.string(),
    projectId: z.number(),
    sector: z.string(),
    accommodationType: z.string(),
    numberOfNights: z.number(),
    guestCount: z.number(),
    isExternal: z.boolean(),
    label: z.string().nullable(),
    source: z.string().nullable(),
    tags: z
      .object({
        values: z
          .array(z.object({ id: z.number(), name: z.string() }))
          .optional(),
      })
      .optional(),
  }),
);

export type QuestionAccommodationPublicDto = {
  id: number;
  userId: string;
  projectId: number;
  sector: string;
  accommodationType: string;
  numberOfNights: number;
  guestCount: number;
  isExternal: boolean;
  label: string | null;
  source?: string | null;
  tags?: { values?: Array<{ id: number; name: string }> };
};
